export default __webpack_public_path__ + "static/media/hero-800w.acf66ab7.png";